import React, { useEffect, useRef, useState } from 'react';
import './Invite.css';
import { useLanguage } from './LanguageContext';
import translations from './translations';

function Invite() {
  const { language } = useLanguage();
  const t = translations[language];
  const imgRef = useRef(null);
  const [blur, setBlur] = useState(10);

  useEffect(() => {
    const handleScroll = () => {
      if (!imgRef.current) return;
      const rect = imgRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const start = windowHeight * 1.2;
const end = windowHeight * 0.5;
      const progress = (start - rect.top) / (start - end);
      const clamped = Math.min(Math.max(progress, 0), 1);
      setBlur(Math.round(10 - clamped * 10));
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="invite-section">
      <div
        className="invite-left"
        ref={imgRef}
        style={{ filter: `blur(${blur}px)` }}
      >
        <img src="/2.png" alt="Be a part of Fashion Week" />
        <div className="invite-img-text">
  <p>{t.inviteImgText}</p>
</div>
      </div>

     <div className="invite-right" style={{ filter: `blur(${blur}px)` }}>
  <p>{t.inviteP1}</p>
  <p>{t.inviteP2}</p>
</div>
    </div>
  );
}

export default Invite;